export const unitMediaEn = {
  unitMedia: {
    // Main Media page (UnitMedia.vue)
    page: {
      photosLabel: 'Photos [{count}]',
      floorplansLabel: 'Floorplans [{count}]',
      videosLabel: 'Videos [{count}]',
      virtualToursLabel: 'Virtual Tours [{count}]',
      listingScoresPhotos: 'Upload and enable 8 or more photos to improve your Listing score.',
      listingScoresFloorplans: 'Upload and enable 1 or more floorplan(s) to improve your Listing Score.',
      listingScoresVideos: 'Upload and enable 1 or more video(s) to improve your Listing Score.',
      listingScoresVirtualTours: 'Upload and enable 1 or more virtual tour(s) to improve your Listing Score.',
      importerActivityTitle: 'Importer Activity',
      importerActivityMessage: 'This section is managed by {source}. Changes made will be temporary.',
      videoHelpTooltip: 'Upload and enable Videos at the property level to select at the unit level.',
      virtualTourHelpTooltip: 'Upload and enable Virtual Tours at the property level to select at the unit level.',
      goToPropertyMedia: 'Go To Property Media',
      footerUnitId: 'Unit ID: {unitId}',
      // `{'|'}` escapes the pipe: vue-i18n v9 reads a bare `|` as the plural-choice separator and a
      // leading one throws "Plural must have messages", which left the Unit Media page spinning forever
      footerImportId: '{\'|\'} Import ID: {importId}',
    },

    // Photos (RsPartialUnitMediaPhotoList.vue)
    photos: {
      aiBanner: 'Level up your photos with Rentsync\'s new AI Enhanced photo editor! Select your photo and click "Enhance Photo" under Media Details to try it out.',
      promotionalBannerMain: 'Images that contain promotional content may not show within photo carousels on some rental listing sites.',
      promotionalBannerLink: 'Consider adding the image in the dedicated Promotions section instead -',
      enabledPhotos: 'Enabled Photos [{count}]',
      disabledPhotos: 'Disabled Photos [{count}]',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      addPhoto: 'Add Photo',
      disable: 'Disable',
      enable: 'Enable',
      deleteAll: 'Delete All',
      uploadDragText: 'Drag here or',
      uploadBrowse: 'browse',
      uploadDragSuffix: 'to upload',
      uploadMaxSize: 'Maximum size limit per file: 32Mb',
      uploadSettingsTitle: 'Upload Settings',
      uploadSuccessTitle: 'Upload success!',
      uploadSuccessMessage: '{count} uploads completed!',
      uploadMaxSizeError: 'Maximum size limit is 32 MB.',
      uploadMaxSizeErrorTitle: 'Can\'t upload!',
      uploadFailTitle: 'Your photos were successfully uploaded except for the following:',
      invalidFileTitle: 'Invalid File Type',
      invalidFileText: 'Please upload a file with a .jpg, .jpeg, .png, or .gif extension.',
      disableConfirmTitle: 'Are you sure you want to disable the following assigned photos?',
      deleteConfirmTitle: 'Are you sure you want to remove the following photos?',
      deletedToast: '{count} photos deleted!',
      visibilityUpdated: 'Visibility updated!',
      savedToast: 'Changes saved!',
      partialSaveError: '{failed} of {total} photo changes could not be saved: {detail}',
    },

    // Floorplans (RsPartialUnitFloorplanList.vue)
    floorplans: {
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      uploadFormatInfo: 'Floorplans can be uploaded as a PDF, image file, or both. This is done because some websites may display the image file and link to the PDF.',
      uploadFormatTip: 'For a better experience, drag and drop only images or only PDFs at a time, instead of both formats together.',
      addFloorplan: 'Add Floorplan',
      addUnitFloorplan: 'Add Unit Floorplan',
      deleteAll: 'Delete All',
      uploadDragText: 'Drag here or',
      uploadBrowse: 'browse',
      uploadDragSuffix: 'to upload',
      uploadMaxSize: 'Maximum size limit per file: 32Mb',
      uploadSettingsTitle: 'Upload Settings',
      uploadSuccessTitle: 'Upload success!',
      uploadSuccessMessage: 'Your floor plans have been uploaded successfully!',
      uploadFailTitle: 'Failed to upload the following floorplans:',
      deleteTitle: 'Delete Floorplan(s)',
      deleteCountText: 'Number of items that will be deleted: {count}',
      deletedToast: '{count} item(s) deleted!',
      deletedExceptToast: '{count} item(s) deleted! Except {failed} item(s).',
      visibilityUpdated: 'Visibility updated!',
    },

    // Floorplan Details Panel (RsPartialUnitFloorplanDetails.vue)
    floorplanDetails: {
      cardTitle: 'Media Details',
      editButton: 'Edit Media Details',
      popoutTitle: 'Floor Plans',
      previewImage: 'Preview Image',
      previewPdf: 'Preview PDF',
      labelImageName: 'Image Name:',
      labelPdfName: 'PDF Name:',
      labelName: 'Name:',
      labelDescription: 'Description:',
      labelSqft: 'Sqft:',
      labelTags: 'Tags:',
      formLabelName: 'Name',
      formLabelDescription: 'Description',
      formLabelTags: 'Tags',
      formLabelImage: 'Image:',
      formLabelPdf: 'PDF:',
      attachImage: 'Attach Image',
      replaceImage: 'Replace Image',
      attachPdf: 'Attach PDF',
      replacePdf: 'Replace PDF',
      saveEdits: 'Save Edits',
      noPreview: 'No Preview Available',
      selectPrompt: 'Select a file to preview here',
      editsToastMessage: 'Edits saved!',
    },

    // Video / Virtual Tour Selector (RsPartialUnitVideoSelector.vue)
    videoSelector: {
      selectVideo: 'Select Video',
      selectVirtualTour: 'Select Virtual Tour',
      noVideosAvailable: 'No Videos Available',
      noVirtualToursAvailable: 'No Virtual Tours Available',
    },
  },
} as const;

export const unitMediaFr = {
  unitMedia: {
    page: {
      photosLabel: 'Photos [{count}]',
      floorplansLabel: 'Plans d\'étage [{count}]',
      videosLabel: 'Vidéos [{count}]',
      virtualToursLabel: 'Visites virtuelles [{count}]',
      listingScoresPhotos: 'Téléversez et activez 8 photos ou plus pour améliorer votre score d\'annonce.',
      listingScoresFloorplans: 'Téléversez et activez 1 plan d\'étage ou plus pour améliorer votre score d\'annonce.',
      listingScoresVideos: 'Téléversez et activez 1 vidéo ou plus pour améliorer votre score d\'annonce.',
      listingScoresVirtualTours: 'Téléversez et activez 1 visite virtuelle ou plus pour améliorer votre score d\'annonce.',
      importerActivityTitle: 'Activité de l\'importateur',
      importerActivityMessage: 'Cette section est gérée par {source}. Les modifications apportées seront temporaires.',
      videoHelpTooltip: 'Téléversez et activez des vidéos au niveau de la propriété pour les sélectionner au niveau de l\'unité.',
      virtualTourHelpTooltip: 'Téléversez et activez des visites virtuelles au niveau de la propriété pour les sélectionner au niveau de l\'unité.',
      goToPropertyMedia: 'Accéder aux médias de la propriété',
      footerUnitId: 'ID de l\'unité : {unitId}',
      // `{'|'}` escapes the pipe: vue-i18n v9 reads a bare `|` as the plural-choice separator
      footerImportId: '{\'|\'} ID d\'importation : {importId}',
    },

    photos: {
      aiBanner: 'Améliorez vos photos avec le nouvel éditeur de photos IA de Rentsync ! Sélectionnez votre photo et cliquez sur « Améliorer la photo » sous Détails des médias pour l\'essayer.',
      promotionalBannerMain: 'Les images à caractère promotionnel pourraient ne pas s’afficher dans les carrousels de photos de certains sites d’annonces locatives.',
      promotionalBannerLink: 'Envisagez plutôt d’ajouter l’image dans la section dédiée aux promotions -',
      enabledPhotos: 'Photos activées [{count}]',
      disabledPhotos: 'Photos désactivées [{count}]',
      selectAll: 'Sélectionner tout',
      deselectAll: 'Désélectionner tout',
      addPhoto: 'Ajouter une photo',
      disable: 'Désactiver',
      enable: 'Activer',
      deleteAll: 'Tout supprimer',
      uploadDragText: 'Glisser ici ou',
      uploadBrowse: 'parcourir',
      uploadDragSuffix: 'pour téléverser',
      uploadMaxSize: 'Taille maximale par fichier : 32 Mo',
      uploadSettingsTitle: 'Paramètres de téléversement',
      uploadSuccessTitle: 'Téléversement réussi !',
      uploadSuccessMessage: '{count} téléversement(s) terminé(s) !',
      uploadMaxSizeError: 'La taille maximale autorisée est de 32 Mo.',
      uploadMaxSizeErrorTitle: 'Impossible de téléverser !',
      uploadFailTitle: 'Vos photos ont été téléversées avec succès, sauf les suivantes :',
      invalidFileTitle: 'Type de fichier invalide',
      invalidFileText: 'Veuillez téléverser un fichier avec l\'extension .jpg, .jpeg, .png ou .gif.',
      disableConfirmTitle: 'Êtes-vous sûr de vouloir désactiver les photos assignées suivantes ?',
      deleteConfirmTitle: 'Êtes-vous sûr de vouloir supprimer les photos suivantes ?',
      deletedToast: '{count} photo(s) supprimée(s) !',
      visibilityUpdated: 'Visibilité mise à jour !',
      savedToast: 'Modifications enregistrées !',
      partialSaveError: '{failed} modification(s) de photo sur {total} n\'ont pas pu être enregistrées : {detail}',
    },

    floorplans: {
      selectAll: 'Sélectionner tout',
      deselectAll: 'Désélectionner tout',
      uploadFormatInfo: 'Les plans d\'étage peuvent être téléversés en tant que PDF, fichier image ou les deux. Certains sites web peuvent afficher le fichier image et créer un lien vers le PDF.',
      uploadFormatTip: 'Pour une meilleure expérience, glissez-déposez uniquement des images ou uniquement des PDF à la fois, plutôt que les deux formats ensemble.',
      addFloorplan: 'Ajouter un plan d\'étage',
      addUnitFloorplan: 'Ajouter un plan d\'étage d\'unité',
      deleteAll: 'Tout supprimer',
      uploadDragText: 'Glisser ici ou',
      uploadBrowse: 'parcourir',
      uploadDragSuffix: 'pour téléverser',
      uploadMaxSize: 'Taille maximale par fichier : 32 Mo',
      uploadSettingsTitle: 'Paramètres de téléversement',
      uploadSuccessTitle: 'Téléversement réussi !',
      uploadSuccessMessage: 'Vos plans d\'étage ont été téléversés avec succès !',
      uploadFailTitle: 'Échec du téléversement des plans d\'étage suivants :',
      deleteTitle: 'Supprimer le(s) plan(s) d\'étage',
      deleteCountText: 'Nombre d\'éléments à supprimer : {count}',
      deletedToast: '{count} élément(s) supprimé(s) !',
      deletedExceptToast: '{count} élément(s) supprimé(s) ! Sauf {failed} élément(s).',
      visibilityUpdated: 'Visibilité mise à jour !',
    },

    floorplanDetails: {
      cardTitle: 'Détails des médias',
      editButton: 'Modifier les détails des médias',
      popoutTitle: 'Plans d\'étage',
      previewImage: 'Aperçu de l\'image',
      previewPdf: 'Aperçu du PDF',
      labelImageName: 'Nom de l\'image :',
      labelPdfName: 'Nom du PDF :',
      labelName: 'Nom :',
      labelDescription: 'Description :',
      labelSqft: 'Superficie (pi²) :',
      labelTags: 'Étiquettes :',
      formLabelName: 'Nom',
      formLabelDescription: 'Description',
      formLabelTags: 'Étiquettes',
      formLabelImage: 'Image :',
      formLabelPdf: 'PDF :',
      attachImage: 'Joindre l\'image',
      replaceImage: 'Remplacer l\'image',
      attachPdf: 'Joindre le PDF',
      replacePdf: 'Remplacer le PDF',
      saveEdits: 'Enregistrer les modifications',
      noPreview: 'Aperçu non disponible',
      selectPrompt: 'Sélectionnez un fichier pour l\'aperçu',
      editsToastMessage: 'Modifications enregistrées !',
    },

    videoSelector: {
      selectVideo: 'Sélectionner une vidéo',
      selectVirtualTour: 'Sélectionner une visite virtuelle',
      noVideosAvailable: 'Aucune vidéo disponible',
      noVirtualToursAvailable: 'Aucune visite virtuelle disponible',
    },
  },
} as const;
